import React from 'react';
import { Card, Table } from 'react-bootstrap';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
const NUMBER_OF_ITEMS = 5;
const MyTasks = _ref => {
  let {
    tasks
  } = _ref;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const columns = [{
    text: ''
  }];
  if (!tasks) {
    return null;
  }
  const rows = tasks.slice(0, NUMBER_OF_ITEMS).map(task => {
    return {
      taskData: [`${task.claim_project_report.claim_group.company.name} - ${task.title}`, `${location.pathname}/time_tracking/my_tasks?page=1&query=`]
    };
  });
  const handleViewAllTasks = () => {
    history.push(`${location.pathname}/time_tracking/my_tasks?page=1&query=`);
  };
  return /*#__PURE__*/React.createElement(Card, {
    className: "px-4 py-3 h-100"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "font-weight-bold"
  }, t('my_tasks')), rows.length === 0 ? /*#__PURE__*/React.createElement("p", {
    className: "text-center text-secondary"
  }, t('no_tasks_assigned')) : /*#__PURE__*/React.createElement(Table, {
    className: "table borderless"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, columns.map((column, index) => {
    return /*#__PURE__*/React.createElement("th", {
      key: index
    }, column.text);
  }))), /*#__PURE__*/React.createElement("tbody", null, rows.map((row, index) => {
    return /*#__PURE__*/React.createElement("tr", {
      key: index
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
      to: row.taskData[1]
    }, row.taskData[0])));
  }))), /*#__PURE__*/React.createElement("hr", {
    className: "mt-auto"
  }), /*#__PURE__*/React.createElement(Button, {
    className: "me-auto",
    onClick: handleViewAllTasks,
    variant: "text"
  }, t('view_all_tasks')));
};
export default MyTasks;